import {
  Button,
  Table,
  TableContainer,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
  HStack,
  Spinner,
  Select as ChakraSelect,
  Heading,
  Box,
  Divider,
} from "@chakra-ui/react";
import React, { useContext, useState, useEffect } from "react";
import { RoughNotation } from "react-rough-notation";
import { Helmet } from "react-helmet";
import Select from "react-select";
import { AdminGetOtpHistoryAPI, AdminJiomartHistoryAPI } from "../../../utils/api";
import OtpHistoryCard from "../components/OtpHistoryCard";
import { AppContext } from "../../../context/AppContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FaArrowLeft, FaSyncAlt } from "react-icons/fa";

const DurationData = [
  { label: "All time", value: "all" },
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Last 7 days", value: "lastWeek" },
  { label: "Last 30 days", value: "lastMonth" },
];

const StatusData = [
  { label: "All", value: "all" },
  { label: "Success", value: "success" },
  { label: "Pending", value: "pending" },
  { label: "Cancelled", value: "cancelled" },
];

const ServiceNameData = [
  { label: "All Services", value: "all" },
  { label: "Jiomart", value: "jiomart" },
  { label: "Flipkart", value: "flipkart" },
];

const JiomartHistory = () => {
  const { AdminToken } = useContext(AppContext);
  const [pageNo, setPageNo] = useState(1);
  const [limitNo, setLimitNo] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [durationFilter, setDurationFilter] = useState("today");
  const [statusFilter, setStatusFilter] = useState("all");
  const [serviceNameFilter, setServiceNameFilter] = useState("all");
  const [data, setData] = useState([]);
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [totalOtpPrice, setTotalOtpPrice] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(false);
    AdminJiomartHistoryAPI(AdminToken, pageNo, limitNo, durationFilter, statusFilter, userId, serviceNameFilter)
      .then((res) => {
        setLoading(true);
        setData(res.data.data);
        setTotalPages(res.data.total_pages);
        setTotalOtpPrice(res.data.totalMobileOtpPrice);
      })
      .catch((err) => {
        setLoading(true);
        console.error("Error fetching OTP history:", err);
      });
  }, [limitNo, pageNo, durationFilter, statusFilter, userId, refreshKey, serviceNameFilter]);

  return (
    <>
      <Helmet>
        <title>OTP History | Techy India</title>
      </Helmet>

      <VStack
        align="start"
        bg="white"
        p={["0.8rem 0.5rem", "1rem 1rem", "1.5rem 2rem"]}
        w="100%"
        minH="100vh"
        gap="1.5rem"
      >
        {/* Page Header */}
        <VStack align="start" w="100%">
          <Heading size="lg" display={'flex'} alignItems={'center'}>
            {userId && <Box as={FaArrowLeft} cursor={'pointer'} w={'1.5rem'} h={'1.5rem'} marginRight={'1rem'} onClick={() => { navigate('/admin/otp-history', { replace: true }) }} className="cursor-pointer w-8 h-8" />}
            OTP{" "}
            <RoughNotation
              strokeWidth={2}
              color="crimson"
              type="underline"
              show={true}
            >
              History
            </RoughNotation>
          </Heading>
        </VStack>

        {/* Filter Bar */}
        <Box
          w="100%"
          bg="gray.50"
          p="1rem"
          borderRadius="md"
          boxShadow="sm"
          display="flex"
          flexWrap="wrap"
          justifyContent="space-between"
          alignItems="center"
          gap="0.5rem"
        >
          <HStack w={["100%", "100%", "30%", "30%"]}>
            <Select
              onChange={(e) => {
                setDurationFilter(e.value);
                setPageNo(1);
              }}
              defaultValue={DurationData[1]}
              options={DurationData}
              styles={{
                container: (base) => ({
                  ...base,
                  width: "100%",
                }),
              }}
              theme={(theme) => ({
                ...theme,
                borderRadius: 8,
                colors: {
                  ...theme.colors,
                  primary25: "rgba(255, 227, 233, 0.63)",
                  primary: "rgb(231 70 102)",
                },
              })}
            />
          </HStack>

          <HStack w={["100%", "100%", "30%", "30%"]}>
            <Select
              onChange={(e) => {
                setServiceNameFilter(e.value);
                setPageNo(1);
              }}
              defaultValue={ServiceNameData[0]}
              options={ServiceNameData}
              styles={{
                container: (base) => ({
                  ...base,
                  width: "100%",
                }),
              }}
              theme={(theme) => ({
                ...theme,
                borderRadius: 8,
                colors: {
                  ...theme.colors,
                  primary25: "rgba(255, 227, 233, 0.63)",
                  primary: "rgb(231 70 102)",
                },
              })}
            />
          </HStack>

          <HStack w={["100%", "100%", "45%", "35%"]}>
            <Select
              onChange={(e) => {
                setStatusFilter(e.value);
                setPageNo(1);
              }}
              defaultValue={StatusData[0]}
              options={StatusData}
              styles={{
                container: (base) => ({
                  ...base,
                  width: "100%",
                }),
              }}
              theme={(theme) => ({
                ...theme,
                borderRadius: 8,
                colors: {
                  ...theme.colors,
                  primary25: "rgba(255, 227, 233, 0.63)",
                  primary: "rgb(231 70 102)",
                },
              })}
            />
          </HStack>

          {userId && <HStack fontSize={'1rem'} fontWeight={700}>
            <Text>Total</Text> <Text as={'span'} color={'green'}>₹{totalOtpPrice}</Text>
          </HStack>
          }
          <HStack>
            <Text fontSize="sm" color="gray.600">
              Items per page:
            </Text>
            <ChakraSelect
              w="80px"
              onChange={(e) => {
                setLimitNo(Number(e.target.value));
                setPageNo(1);
              }}
              value={limitNo}
            >
              {[10, 20, 40, 60, 80, 100].map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </ChakraSelect>
          </HStack>

          <Button
            leftIcon={<FaSyncAlt />}
            colorScheme="red"
            variant="outline"
            size="sm"
            onClick={() => setRefreshKey((k) => k + 1)}
            isLoading={!loading}
            loadingText="Refreshing"
          >
            Refresh
          </Button>
        </Box>

        <Divider />

        {/* Loading State */}
        {!loading && (
          <VStack justify="center" w="100%" minH="50vh">
            <Spinner
              thickness="5px"
              speed="0.55s"
              emptyColor="gray.200"
              color="red.400"
              size="xl"
            />
            <Text color="gray.500">Loading OTP history...</Text>
          </VStack>
        )}

        {/* Data Table */}
        {data.length && loading ? (
          <TableContainer
            w="100%"
            boxShadow="md"
            borderRadius="md"
            overflowX="auto"
            bg="white"
          >
            <Table variant="simple" size={["sm", "md"]}>
              <Thead bg="crimson">
                <Tr>
                  {[
                    "Email",
                    "Service",
                    "Price",
                    "Mobile",
                    "Status",
                    "OTP",
                    "Date",
                  ].map((head) => (
                    <Th
                      key={head}
                      color="white"
                      textAlign="center"
                      p="0.8rem"
                      fontSize="sm"
                    >
                      {head}
                    </Th>
                  ))}
                </Tr>
              </Thead>
              <Tbody>
                {data.map((el, index) => (
                  <OtpHistoryCard
                    otp={el}
                    index={index}
                  />
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        ) : (
          <></>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <HStack
            gap="0.8rem"
            align="center"
            justify="center"
            w="100%"
            mt="1.5rem"
          >
            <Button
              colorScheme="red"
              variant="outline"
              onClick={() => setPageNo((p) => Math.max(1, p - 1))}
              isDisabled={pageNo === 1}
            >
              {"<<"}
            </Button>
            <Text
              fontWeight="bold"
              fontSize="md"
              border="1px solid"
              borderColor="gray.300"
              px="1rem"
              py="0.2rem"
              borderRadius="md"
            >
              {pageNo}
            </Text>
            <Text fontWeight="bold" color="gray.600">
              / {totalPages}
            </Text>
            <Button
              colorScheme="red"
              variant="outline"
              onClick={() =>
                setPageNo((p) => (p < totalPages ? p + 1 : p))
              }
              isDisabled={pageNo >= totalPages}
            >
              {">>"}
            </Button>
          </HStack>
        )}
      </VStack>
    </>
  );
};

export default JiomartHistory;
